import React from 'react';
import { Link } from 'react-router-dom';
interface OfferCardProps {
  title: string;
  subtitle: string;
  benefits: string[];
  buttonText: string;
  buttonHref: string;
  isPrimary?: boolean;
  icon?: React.ReactNode;
}
export function OfferCard({
  title,
  subtitle,
  benefits,
  buttonText,
  buttonHref,
  isPrimary = false,
  icon
}: OfferCardProps) {
  const baseClasses = 'bg-white rounded-3xl p-8 relative transition-all duration-300 text-center';
  const primaryClasses = 'border-2 border-[#1D4ED8] shadow-[0_20px_40px_rgba(29,78,216,0.08)] transform lg:-translate-y-4';
  const secondaryClasses = 'border border-[rgba(0,0,0,0.06)] hover:shadow-[0_12px_30px_rgba(0,0,0,0.06)]';
  return <div className={`${baseClasses} ${isPrimary ? primaryClasses : secondaryClasses}`} data-id="element-125">
      {isPrimary && <div className="absolute -top-4 inset-x-0 flex justify-center" data-id="element-126">
          <span className="bg-[#1D4ED8] text-white font-['Montserrat'] text-[10px] font-bold tracking-[0.15em] uppercase px-4 py-1.5 rounded-full shadow-md" data-id="element-127">
            ★ CEL MAI RECOMANDAT
          </span>
        </div>}

      <div className="w-14 h-14 bg-[#EFF6FF] rounded-2xl flex items-center justify-center mb-6 mt-2 mx-auto text-[#1D4ED8]" data-id="element-128">
        {icon || <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-129">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-130" />
          </svg>}
      </div>

      <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-2" data-id="element-131">
        {title}
      </h3>
      <p className="font-['Inter'] text-[19px] text-[#6B7280] mb-8" data-id="element-132">
        {subtitle}
      </p>

      <ul className="space-y-4 mb-8 text-left" data-id="element-133">
        {benefits.map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-134">
            <div className="w-5 h-5 rounded-full bg-[#EFF6FF] flex items-center justify-center flex-shrink-0 mt-1" data-id="element-135">
              <svg className="w-3 h-3 text-[#1D4ED8]" fill="currentColor" viewBox="0 0 20 20" data-id="element-136">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-137" />
              </svg>
            </div>
            <span className="font-['Inter'] text-[17px] font-light text-[#4B5563] leading-[1.6]" data-id="element-138">
              {text}
            </span>
          </li>)}
      </ul>

      <a href="https://calendly.com/valerdura-coaching/sesiune-descoperire" target="_blank" rel="noopener noreferrer" className="block w-full font-['Montserrat'] text-[15px] font-bold bg-[#1D4ED8] text-white px-6 py-4 rounded-xl shadow-[0_8px_20px_rgba(29,78,216,0.3)] hover:bg-[#2563EB] hover:-translate-y-0.5 transition-all duration-300 text-center no-underline" data-id="element-139">
        {buttonText}
      </a>
    </div>;
}